import gql from 'graphql-tag'

export const fetchProductsSearchQuery = gql(`
  query (
    
    $search: String
    $currentPage: Int!
    $pageSize: Int = 5
  ) {
    products(
      search: $search
      pageSize: $pageSize
      currentPage: $currentPage
    ) {
      items {
        sku
        your_price_tax
        catalog_product_name
        name
        small_image {
          url
        }
        ... on BundleProduct {
          bundle_price_sum_tax
        }
      }
    }
  }
`)
